import { ThemeProvider } from "@mui/material";
import React from "react";
import { Router } from "router";
import { theme } from "styles/theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router />
    </ThemeProvider>
  );
}

export default App;
